export default __webpack_public_path__ + "static/media/logo.a72c505d.svg";